import lightGallery from 'lightgallery';
import { LightGallery } from 'lightgallery/lib';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';

import Component from '../component/component';
import Icon from '../icon/icon';

import 'lightgallery/scss/lightgallery-core.scss';
import './lightbox.scss';

export default class Lightbox extends Component {
    static initSelector: string = '.lightbox';

    public button: HTMLElement;
    hasInitialized: boolean;

    constructor(target: HTMLElement) {
        super(target);

        this.button = this.element.querySelector('.lightbox__button');
        this.hasInitialized = false;

        this.init();
    }

    init(): void {
        if (this.button && !this.element.classList.contains('lightbox-gallery')) {
            this.button.addEventListener('click', this.buttonClickHandler.bind(this));
        } else {
            if (!window.gotoAndPlay.vimeoApiLoaded) {
                this.loadVimeoAPI(() => {
                    this.initLightGallery(false);
                });
            } else {
                this.initLightGallery(false);
            }
        }
    }

    buttonClickHandler(): void {
        if (!this.hasInitialized) {
            if (!window.gotoAndPlay.vimeoApiLoaded) {
                this.loadVimeoAPI(() => {
                    this.initLightGallery(true);
                });
            } else {
                this.initLightGallery(true);
            }

            this.hasInitialized = true;
        }
    }

    loadVimeoAPI(callback: () => void): void {
        const script: HTMLScriptElement = document.createElement('script');

        script.src = 'https://player.vimeo.com/api/player.js';
        script.type = 'text/javascript';
        script.addEventListener('load', callback);
        document.body.appendChild(script);
        window.gotoAndPlay.vimeoApiLoaded = true;
    }

    initLightGallery(openOnInit?: boolean): void {
        const selectorData: string = '.lightbox__item .image__link, .lightbox__item .lightbox__button';
        const thumbnailData: boolean = this.element.dataset.simple ? false : true;

        const gallery: LightGallery = lightGallery(this.element, {
            addClass: 'lightbox__container',
            download: false,
            exThumbImage: 'data-external-thumb-image',
            licenseKey: window.gotoAndPlay.lightboxApiKey,
            mobileSettings: {
                showCloseIcon: true,
            },
            plugins: [lgThumbnail, lgVideo],
            selector: selectorData,
            thumbnail: thumbnailData,
        });

        if (openOnInit) {
            gallery.openGallery();
        }

        Array.prototype.forEach.call(document.getElementsByClassName('lg-prev'), (element: HTMLElement) => {
            const prevIcon: string = Icon.render('arrow-left', '', 'lightbox__icon lightbox__icon--left');

            element.innerHTML = prevIcon;
        });

        Array.prototype.forEach.call(document.getElementsByClassName('lg-next'), (element: HTMLElement) => {
            const nextIcon: string = Icon.render('arrow-right', '', 'lightbox__icon lightbox__icon--right');

            element.innerHTML = nextIcon;
        });

        Array.prototype.forEach.call(document.getElementsByClassName('lg-close'), (element: HTMLElement) => {
            const closeIcon: string = Icon.render('close', '', 'lightbox__icon lightbox__icon--close');

            element.innerHTML = closeIcon;
        });
    }
}
